'use strict';
var config = { get: function (param) { return ''; } };
if (typeof window !== 'undefined') {
    var Dropzone = require('dropzone');
    window.Dropzone = Dropzone;
    var jQuery = window.jQuery;
    Dropzone.autoDiscover = false;
    Dropzone.prototype.__addFilesFromItems = Dropzone.prototype._addFilesFromItems;
    Dropzone.prototype._handleFiles = Dropzone.prototype.handleFiles;
    Dropzone.prototype._addFilesFromItems = function (items) {
        this.__addFilesFromItems(items);
        this.processAdded();
    };
    Dropzone.prototype.handleFiles = function (files) {
        this._handleFiles(files);
        this.processAdded();
    };
    Dropzone.prototype.updateOrder = function () {
        var cfg = this.options.config;
        var self = this;
        if (cfg.sortable && jQuery(this.$previewsContainer).children('.dz-preview:not(.dz-error)').length > 0) {
            console.log('reordering files');
            jQuery.ajax({
                method: 'POST',
                url: this.options.url + '/reorder',
                data: {
                    sid: cfg.sid,
                    website_id: cfg.website_id,
                    ids: jQuery(this.$previewsContainer).children('.dz-preview:not(.dz-error)').map(function (i, el) {
                        return jQuery(el).data('id');
                    }).get().join(',')
                }
            })
                .done(function (result) {
                self.$element.triggerHandler('imagesReordered', [self, jQuery(self.$previewsContainer).children('.dz-preview:not(.dz-error)').map(function (i, el) {
                        return jQuery(el).data('id');
                    })]);
                self.$element.triggerHandler('primaryImageUpdated', [self, (result && result.primary ? result.primary : false)]);
            });
        }
    };
    Dropzone.prototype.updateProgressbar = function () {
        if (this.options.config.progressbar) {
            var l = this.pending.length + this.files.length + this.errors.length + this.completed.length, wp = 0, wc = 0, we = 0, wf = l === 0 ? 0 : 100 / l;
            this.files.forEach(function (file) {
                switch (file.status) {
                    case 'added':
                    case 'queued':
                        wp += wf * 0.0;
                        break;
                    case 'uploading':
                        wp += wf * (file.upload.progress / 100.0);
                        break;
                    case 'error':
                        we += wf * 1.0;
                        break;
                    case 'success':
                        wc += wf * 1.0;
                        break;
                }
            });
            we += this.errors.length * wf;
            wc += this.completed.length * wf;
            this.$element.find('.dz-progress-bar').removeClass('hidden')
                .find('.progress-bar-primary').css('width', wc + '%').text((wc + we).toFixed(0) + '% complete').end()
                .find('.progress-bar-striped').css('width', wp + '%').end()
                .find('.progress-bar-danger').css('width', we + '%').end()
                .find('.small').text(this.completed.length + ' of ' + l + ' imported' + (this.errors.length ? ' (' + this.errors.length + ' errors)' : ''));
        }
    };
    Dropzone.prototype.reset = function () {
        this.added = [];
        this.pending = [];
        this.completed = [];
        this.errors = [];
        this.files = [];
        this.$previewsContainer.empty();
        this.$element.find('.dz-progress-bar').addClass('hidden');
    };
    Dropzone.prototype.processPending = function (files) {
        if (files && files.length) {
            files.forEach(function (file) {
                file.status = Dropzone.ADDED;
                file.upload = { progress: 0, total: file.size, bytesSent: 0 };
            });
            this.pending.push.apply(this.pending, files);
            this.pending.sort(function (file1, file2) {
                if (file1.name < file2.name)
                    return -1;
                if (file1.name > file2.name)
                    return 1;
                return 0;
            });
        }
        if (this.pending.length && this.files.length < this.options.parallelUploads * 2) {
            var file = this.pending.shift();
            var self = this;
            this.files.push(file);
            this.addPreview(file);
            this._enqueueThumbnail(file);
            this.accept(file, function (err) {
                if (err) {
                    file.accepted = false;
                    self._errorProcessing([file], err);
                }
                else {
                    file.accepted = true;
                    self.enqueueFile(file);
                }
                self._updateMaxFilesReachedClass();
                setTimeout(function () { self.processPending(); }, 0);
            });
        }
    };
    Dropzone.prototype.processAdded = function () {
        var evt = jQuery._data(this.element, 'events'), added = this.added.slice();
        this.added.length = 0;
        if (evt && evt.addedfiles && evt.addedfiles.length) {
            return this.$element.triggerHandler('addedfiles', [this, added]);
        }
        this.processPending(added);
    };
    Dropzone.prototype.addFile = function (file) { this.added.push(file); };
    Dropzone.prototype.addPreview = function (file, incrementProgressBar) {
        if (arguments.length < 2)
            incrementProgressBar = true;
        console.log('added file', file.name);
        var cfg = this.options.config;
        var $p = jQuery(file.previewElement = Dropzone.createElement(window.templates.dropzone_preview(file, cfg, true)));
        if (cfg.deleteBeforeUpload) {
            $p.data('fileToDelete', file);
        }
        if (cfg.maxFiles === 1) {
            this.files = [file];
            this.$previewsContainer.empty();
        }
        // if (cfg.autoProcessQueue) $p.find('.dz-remove').remove()
        file.previewTemplate = file.previewElement;
        this.$previewsContainer.append($p);
        this.$element.find('.dz-sort-help').removeClass('hidden');
        if (incrementProgressBar) {
            this.updateProgressbar();
        }
        return file.previewElement;
    };
    jQuery.fn.disableDropzone = function () {
        if (this.length > 1) {
            this.each(function () { jQuery(this).disableDropzone(); });
            return this;
        }
        var el = this.get(0);
        el.dropzone.disable();
        var $dzp = this.find('.dropzone-previews');
        if ($dzp.sortable && el.dropzone.options.config.sortable)
            $dzp.sortable('disable');
    };
    jQuery.fn.enableDropzone = function () {
        if (this.length > 1) {
            this.each(function () { jQuery(this).enableDropzone(); });
            return this;
        }
        var el = this.get(0);
        el.dropzone.enable();
        var $dzp = jQuery(el).find('.dropzone-previews');
        if ($dzp.sortable && el.dropzone.options.config.sortable)
            $dzp.sortable('enable');
    };
    jQuery.fn.dropzone = function (config) {
        if (this.length > 1) {
            this.each(function () {
                jQuery(this).dropzone(config);
            });
            return this;
        }
        if (this.length < 1) {
            return this;
        }
        var $dz = jQuery(this), $dzp = $dz.find('.dropzone-previews'), 
        // $dzc = jQuery('.dz-sortable'),
        dz;
        var id = $dz.attr('id');
        if (!id) {
            id = Math.round((new Date()).getTime() / 1000);
            $dz.attr('id', id);
        }
        if (!config && $dz[0].hasAttribute('data-dz-init-config')) {
            config = $dz.data('dz-init-config');
        }
        dz = new Dropzone($dz.get(0), {
            config: config,
            method: 'post',
            url: config.url,
            autoProcessQueue: config.autoProcessQueue,
            uploadMultiple: false,
            parallelUploads: 5,
            maxFiles: config.maxFiles,
            acceptedFiles: config.acceptedFiles,
            maxThumbnailFilesize: config.maxThumbnailFilesize || 1,
            clickable: '#' + id + ' .dz-message',
            previewTemplate: '<div class="dz-preview ' + (config.deleteBeforeUpload ? 'dz-preview-with-menu' : '') + ' dropdown"><div><a class="dz-destination_url"><span data-dz-destination_url></span></a></div><a class="dz-options dropdown-toggle fas fa-cog" data-toggle="dropdown"></a><ul class="dropdown-menu dz-menu"></ul><div class="dz-icons"></div><a class="dz-image" data-lightbox=' + config.id + '><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><div class="dz-success-mark"><i class="fas fa-check-circle"></i></div><div class="dz-waiting-mark"><i class="fas fa-circle-notch"></i></div><div class="dz-error-mark"><i class="fas fa-times-circle"></i></div></a><div class="dz-details"><a class="dz-filename" data-dz-name></a><div class="dz-size"><span data-dz-size></span></div></div><div class="dz-error-message"><span data-dz-errormessage></span></div></div>',
            previewsContainer: $dzp.get(0),
            init: function () {
                var self = this, opt = this.options;
                this.added = [];
                this.pending = [];
                this.completed = [];
                this.errors = [];
                this.$element = jQuery(this.element);
                this.$previewsContainer = jQuery(this.previewsContainer);
                (function setupFileInput() {
                    jQuery(self.hiddenFileInput).remove();
                    var input = jQuery('<input type="file"/>').addClass('dz-hidden-input').css({ visibility: 'hidden', position: 'absolute', top: 10, left: 10, width: 0, height: 0 });
                    if (opt.maxFiles && opt.maxFiles > 1)
                        input.attr('multiple', true);
                    if (opt.acceptedFiles)
                        input.attr('accept', opt.acceptedFiles);
                    if (opt.capture != null)
                        input.attr('capture', opt.capture);
                    self.hiddenFileInput = input.appendTo(opt.hiddenInputContainer)
                        .on('change', function () {
                        self.handleFiles(this.files);
                        setupFileInput();
                    })
                        .get(0);
                }());
            },
            sending: function (file, xhr, form) {
                var cfg = this.options.config;
                var destination_url = '';
                console.log('sending file', file.name);
                form.append('sid', cfg.sid);
                //form.append('site_id', cfg.site_id)
                form.append('destination_url', destination_url);
                form.append('website_id', cfg.website_id);
                form.append('thumbnails', cfg.thumbnails);
                form.append('persist', cfg.persist);
                form.append('bucket', cfg.bucket);
                form.append('profile', cfg.profile);
                form.append('dropzone_area', cfg.dropzone_area);
                form.append('is_public', cfg.is_public);
                if (cfg.batch_luid)
                    form.append('batch_luid', cfg.batch_luid);
                if (cfg.uploadtype)
                    form.append('uploadtype', cfg.uploadtype);
                if (cfg.auction_id)
                    form.append('auction_id', cfg.auction_id);
                if (cfg.filename)
                    form.append('filename', cfg.filename);
                if (cfg.path)
                    form.append('path', cfg.path);
                if (cfg.data)
                    for (var name in cfg.data)
                        form.append(name, cfg.data[name]);
                if (file.data)
                    for (var name in file.data)
                        form.append(name, file.data[name]);
            },
            uploadprogress: function (file, progress) {
                jQuery(file.previewElement).find('[data-dz-uploadprogress]').css('width', progress + '%');
                if (progress === 100)
                    jQuery(file.previewElement).find('.dz-progress').hide().end().addClass('dz-waiting');
                this.updateProgressbar();
            },
            complete: function (file) {
                console.log('complete', file.name);
                var cfg = this.options.config;
                var $np = jQuery(window.templates.dropzone_preview(file.result_data, cfg));
                var $p = jQuery(file.previewElement).addClass('dz-complete dz-success');
                // first update the data
                var newData = $np.data();
                var ndKeys = Object.keys(newData);
                for (var i = 0; i < ndKeys.length; i++) {
                    $p.data(ndKeys[i], newData[ndKeys[i]]);
                }
                // then the HTML contents
                $p.html($np.html());
                /*
                var cfg = this.options.config;
                var $p = jQuery(file.previewElement = Dropzone.createElement(window.templates.dropzone_preview(file, cfg)));
                */
                // jQuery(file.previewElement).addClass('dz-complete').html($np.html());
                this.processPending();
                this.updateProgressbar();
            },
            success: function (file, data) {
                console.log('success', file.name, data);
                file.result_data = data;
                this.completed.push(file);
                var evt = jQuery._data(this.element, 'events');
                if (this.options.config.removeOnSuccess) {
                    this.removeFile(file);
                    if (evt && evt.handleSuccessPreview && evt.handleSuccessPreview.length) {
                        this.$element.triggerHandler('handleSuccessPreview', [this, file, data]);
                    }
                    return;
                }
                var cfg = this.options.config;
                var buster = '?_=' + new Date().getTime();
                if (cfg.databaseField) {
                    var update_url = window.location.pathname + '/image_uploaded';
                    console.log('sending filename to database: ' + update_url);
                    jQuery.ajax({
                        method: 'post',
                        url: update_url,
                        data: {
                            sid: cfg.sid,
                            website_id: cfg.website_id,
                            field: cfg.databaseField,
                            filename: data.file_name
                        }
                    });
                }
                if (evt && evt.handleSuccessPreview && evt.handleSuccessPreview.length) {
                    this.$element.triggerHandler('handleSuccessPreview', [this, data]);
                }
                else {
                    this.$element.triggerHandler('handleSuccessfulUpload', [this, data, file.previewElement]);
                }
            },
            error: function (file, data) {
                console.log('error', file, data);
                // this.files = _.without(this.files, file);
                this.files = this.files.filter(function (f) { return f !== file; });
                this.errors.push(file);
                jQuery(file.previewElement)
                    .addClass('dz-error')
                    .find('[data-dz-errormessage]').text(data ? (data.error ? data.error : data) : 'An unexpected error has occured');
            },
            queuecomplete: function () {
                this.files.length = 0;
                this.processPending();
                this.updateOrder();
                this.updateProgressbar();
                var evt = jQuery._data(this.element, 'events');
                if (evt && evt.fullQueueCompleted && evt.fullQueueCompleted.length) {
                    return this.$element.triggerHandler('fullQueueCompleted', [this, this.completed, this.errors]);
                }
            }
        });
        $dz.data('dropzone', dz)
            .on('mouseenter mouseleave', '.dz-image, .dz-filename', function (e) {
            jQuery(e.target).closest('.dz-preview').toggleClass('dz-preview-hover', e.type == 'mouseenter');
        })
            .on('sortstop', function () { dz.updateOrder(); })
            .on('click', '.visibility-file', function (e) {
            e.preventDefault();
            var pe = jQuery(e.target).closest('.dz-preview');
            var is_public = pe.data('public'); // undefined if not set, boolean if set using data(), default on reload - string, but empty - existence check
            if (typeof is_public === 'undefined') {
                console.log('Public is undefined - needs to be set either on dropzone creation or on successful upload');
                is_public = false;
            }
            else if (typeof is_public === 'string') {
                is_public = pe[0].hasAttribute('data-public');
            }
            var p = !is_public;
            jQuery.ajax({
                method: 'post',
                url: config.url + '/visibility',
                data: { sid: config.sid, website_id: config.website_id, id: pe.data('id'), is_public: p }
            })
                .done(function () {
                pe.data('public', p)
                    .find('.dz-icon-visibility').toggleClass('fa-eye text-success', p)
                    .toggleClass('fa-eye-slash text-danger', !p)
                    .attr('title', 'This attachment is ' + (p ? 'public' : 'private')).end()
                    .find('.visibility-file').find('i').toggleClass('fa-eye text-success', !p)
                    .toggleClass('fa-eye-slash text-danger', p).end()
                    .find('span').text(p ? 'Set Private' : 'Set Public');
            });
        })
            .on('click', '.delete-file', function (e) {
            e.preventDefault();
            var $pe = jQuery(e.target).closest('.dz-preview');
            var ev = jQuery.Event('dz.delete-file');
            ev.params = $pe.data('file');
            $dz.trigger(ev);
            if (typeof ev.result === 'undefined') {
                if (ev.isDefaultPrevented()) {
                    // a handler ran and was prevented - skip
                    return;
                }
                // manual prompt - probably didn't run a handler
                ev.result = window.confirm('Delete this file?');
            }
            Promise.resolve(ev.result).then(function (ok) {
                if (!ok)
                    return;
                if ($pe.data('fileToDelete')) {
                    // delete file before upload
                    var file = $pe.data('fileToDelete');
                    var dz = $dz.data('dropzone');
                    dz.removeFile(file);
                    $pe.remove();
                    return;
                }
                if (config.databaseField) {
                    var update_url = window.location.pathname + '/image_uploaded';
                    console.log('sending filename to database: ' + update_url);
                    jQuery.ajax({
                        method: 'post',
                        url: update_url,
                        data: {
                            sid: config.sid,
                            website_id: config.website_id,
                            field: config.databaseField,
                            filename: ''
                        }
                    })
                        .done(function () {
                        $pe.remove();
                        $dz.find('.dz-sort-help').toggleClass('hidden', $dzp.children().length === 0);
                    });
                    return;
                }
                jQuery.ajax({
                    method: 'post',
                    url: config.url + '/delete',
                    data: {
                        sid: config.sid,
                        website_id: config.website_id,
                        id: $pe.data('id'),
                        profile: $pe.data('profile'),
                        bucket: $pe.data('bucket'),
                        link_url: $pe.data('link_url'),
                        file_name: $pe.data('file_name')
                    }
                })
                    .done(function (result) {
                    $pe.remove();
                    $dz.find('.dz-sort-help').toggleClass('hidden', $dzp.children().length === 0);
                    $dz.triggerHandler('imageDeleted', [$dz.data('dropzone'), $pe, $dzp.children()]);
                    $dz.triggerHandler('primaryImageUpdated', [$dz.data('dropzone'), (result && result.primary ? result.primary : false)]);
                });
            });
        });
        if (config.sortable && $dzp.sortable) {
            var sortableConf = {
                scroll: true,
                distance: 5,
                opacity: 0.75,
                tolerance: 'pointer',
                items: '.dz-preview.dz-success',
                appendTo: document.body,
                helper: 'original'
            };
            if (config.connectedWith) {
                sortableConf.connectWith = '.' + config.connectedWith;
            }
            else if (config.connected) {
                sortableConf.connectWith = '.connectedDropzone';
            }
            $dzp.sortable(sortableConf);
            $dzp.on('dragstart', '.dz-preview', function () { return config.sortable ? jQuery(this).is('.dz-success') : false; });
            if ($dz.hasClass('disabled')) {
                $dzp.sortable('disable');
            }
        }
        return this;
    };
    jQuery('.dropzone[data-dz-init-config]').dropzone();
}
else {
    config = require('config');
}
module.exports = function createDropzone(req, options) {
    return Object.assign({
        sid: req.sessionID,
        website_id: req.website.id,
        autoProcessQueue: true,
        url: config.get('server.dropzone.url'),
        maxFiles: 2000,
        sortable: true,
        menu: {
            delete: true,
            title: true,
            visibility: true
        },
        icons: {
            visibility: true
        },
        details: true,
        thumbnails: true,
        persist: true,
        acceptedFiles: null,
        profile: 'image',
        deleteAll: false,
        dropzone_area: 'default',
        is_public: true,
    }, options);
};
//# sourceMappingURL=index.js.map